import React, { useEffect, useState } from 'react';
import TypicalAssetAllocation from '../TypicalAssetAllocation/TypicalAssetAllocation';
import TypicalAssetAllocationReportChart from 'components/Charts/Report/TypicalAssetAllocation';
import { BoxWrapper } from 'components/Base';
import { getTargetAllocationData } from './targetAllocation';

const MorningstarTargetAllocation = ({ score }: { score: number }) => {
  const [data, setData] = useState(null as any);

  useEffect(() => {
    setData(score ? getTargetAllocationData(score) : null);
  }, [score]);

  return (
    <>
      <BoxWrapper
        title="Morningstar Target Allocation Index"
        helperText="Based on suitability score"
      >
        <TypicalAssetAllocation data={data} />
      </BoxWrapper>
      <TypicalAssetAllocationReportChart data={data} />
    </>
  );
};

export default MorningstarTargetAllocation;
